import GoodsInDetail from "./GoodsInDetail";

export default GoodsInDetail;
